import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import GNBArea from "@/pcomponents/test/layout/menu/gnb";
import prj_logo_img from "@/img/logo/plani_logo_400.png";
import { Link,useNavigate } from 'react-router-dom';
import CheckLoginComponent from '@/pcomponents/comp/check/login_check';
import my_axios,{ get_axios_data } from "@/pcomponents/common/axios";
import popupFunc from "@/lib/lyg/popup";
import { setUnreadTot } from '@/store/chat/chat';
import { setUser,removeUser } from '@/store/user/user';
import getXcolumnFunc from '@/pcomponents/common/xcolumn/get_data/get_xcolumn';

const Header=(props:any)=>{
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let user=useSelector((state:any) => state.user);
  useEffect(()=>{
    
    getXcolumnFunc({"user_seq":user.user_seq});
  },[]);

  const goLogOut=()=>{
    my_axios.post( process.env.REACT_APP_API_URL+'/api/comp/basic/user/login/logout',{ 
      token_id: localStorage.intoyou_token,
    },get_axios_data()).then((response) => {
      dispatch(removeUser());
      localStorage.removeItem("intoyou_token");
      navigate("/login");
    });
  };

  return (
    <div id="header">
      <CheckLoginComponent></CheckLoginComponent>
      <div className="header_con">
      <div className="header_top_wrap">
          <div className="logo_area">
            <a onClick={()=>{navigate("/test");}}>
              <img src={user.logo_url?user.logo_url:prj_logo_img} alt="로고" />
            </a>
          </div>
          <div className="header_top_link_wrap">
            <a className="header_top_link_btn" href="https://www.pageshop.co.kr/PreviewBook/Classification" target="_blank" >교재샵</a>
            <span  className="header_top_split" >|</span>
            <a className="header_top_link_btn" onClick={()=>{}} >{user.user_name} 님</a>
            <button className="btn-s2 btn-line-gray ml-4" onClick={goLogOut} >로그아웃</button>
          </div>
        </div>
        <div className="gnb_wrap">
          <GNBArea></GNBArea>
        </div>
      </div>
    </div>
  );
};

export default Header;